export const check = [
  '0 0 32 32',
  `
  <path d="M12.267 26.925c-0.529 0-1.058-0.151-1.587-0.529l-9.824-7.708c-0.982-0.756-1.134-2.191-0.378-3.174s2.191-1.134 3.174-0.378l8.464 6.65c2.645-2.721 4.987-4.987 7.255-7.255 2.645-2.645 5.441-5.29 8.766-8.766 0.907-0.907 2.267-0.907 3.174-0.075s0.907 2.267 0.075 3.174c-3.401 3.476-6.197 6.197-8.842 8.842-2.569 2.494-5.214 5.139-8.388 8.388-0.529 0.529-1.209 0.831-1.889 0.831z"></path>
`,
]
